/**
 * 매뉴얼 장 — `/manual#c1` ~ `#c8` 로 바로 열린다(service-manual). 절은 절 id(`/manual#t-mapping`)로 열리고, 업데이트 소식의 「시연 영상 보기」가 그렇게 잇는다.
 * 장 이름·부제 문구는 `landing:site.manual.chapters.<id>` 에 있다.
 */
export const MANUAL_CHAPTER_IDS = [
  "c1",
  "c2",
  "c3",
  "c4",
  "c5",
  "c6",
  "c7",
  "c8",
] as const;

export type ManualChapterId = (typeof MANUAL_CHAPTER_IDS)[number];

export const isManualChapterId = (value: string): value is ManualChapterId =>
  (MANUAL_CHAPTER_IDS as readonly string[]).includes(value);

/** 장 번호 표기 — 「01」~「08」 */
export const chapterNumber = (index: number) =>
  String(index + 1).padStart(2, "0");
